module.exports = __webpack_public_path__ + "static/img/sz1.c0715e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhsh/sz1.png
// module id = 1XYX
// module chunks = 13